/* eslint-disable */
export default {
  title: 'Audio',
  dialButtonVolume: 'Lautstärke Wahltaste',
  ringtoneVolume: 'Lautstärke Klingelton',
  callVolume: 'Anruflautstärke',
  muteCalls: 'Anrufe stummschalten',
  outputDevice: 'Ausgabegerät',
  inputDevice: 'Eingabegerät',
  micPermission: 'Mikrofonberechtigung',
  noDevice: 'Kein Gerät',
  checkMicPermission: 'Berechtigung überprüfen',
  micNoPermissionMessage:
    'Die App ist nicht berechtigt, ein Mikrofon zu verwenden',
  noLabel: 'Unbekanntes Gerät',
  notSetSinkIdTip:
    'Leider sind Ihre aktuellen Browser-Berechtigungen nicht so eingestellt, dass wir auf Ihre Audio-Ausgabegeräte zugreifen können. {clickHereLink}, um Informationen zum Einrichten anzuzeigen.',
  noLabelTip:
    'Leider sind Ihre aktuellen Browser-Berechtigungen nicht so eingestellt, dass wir auf Ihre Audio-Eingabegeräte zugreifen können.',
  clickHere: 'Klicken Sie hier',
  defaultOutputDevice: 'Standardausgabegerät',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
